import HeaderBar from "./commons/components/HeaderBar";
import * as React from "react";
import { PatientBalance } from "./payment/Balance";
import { Danger, Warning } from "./commons/components/Alerts";
import PatientBalanceList from "./payment/PatientBalanceList";
import "./Payments.scss";
import { sanitize } from "./commons/utils/sanitize";
import { createRoot } from "react-dom/client";

interface PaymentView {
  balances: PatientBalance[];
  practicesPhoneNumbers: string[];
  showRetrieveErrorMessage: boolean;
}

export default function Payment({
  balances,
  practicesPhoneNumbers,
  showRetrieveErrorMessage,
}: PaymentView) {
  return (
    <>
      <HeaderBar title={i18n["Page.Payment.Title"]} />
      {showRetrieveErrorMessage ? (
        <div className="container">
          <Danger>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitize(i18n["Page.Payment.Balances.RetrieveError"]),
              }}
            />
          </Danger>
        </div>
      ) : (
        <div className="container container-small">
          <div className="panel with-shadow v-flex">
            <div className={"panel-title h-flex space-between no-wrap"}>
              <div>{i18n["Page.Payment.Balances.Title"]}</div>
            </div>
            <Warning>{i18n["Page.Payment.Balances.UpdateWarning"]}</Warning>
            <div>
              {i18n["Page.Payment.Balances.Explanations"]}
              <b>{practicesPhoneNumbers.toString()}</b>.
            </div>
            <PatientBalanceList balances={balances} />
            <div className="payment-call-to-action">
              <a
                className="button-primary"
                href="https://smiledoctors.com/make-a-payment/"
                target="_blank"
              >
                {i18n["Page.Payment.Balances.Action"]}
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Payment.loadComponent = (elementId: string, props: PaymentView) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<Payment {...props} />);
};
